import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FluentProvider,
  webLightTheme,
} from '@fluentui/react-components';
import { ErrorCircle20Filled } from '@fluentui/react-icons';
import { useLocalization } from '../atoms/useLocalization';

export interface FeedbackUnavailableDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Dialog shown when CPS (Customer Privacy & Security) compliance
 * prevents feedback from being displayed for the current tenant.
 */
export const FeedbackUnavailableDialog: React.FC<FeedbackUnavailableDialogProps> = ({
  isOpen,
  onClose
}) => {
  const [t] = useLocalization();

  return (
    <FluentProvider theme={webLightTheme}>
      <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
        <DialogSurface style={{ maxWidth: '530px', width: '530px' }}>
          <DialogBody>
            <DialogTitle>{t('feedbackUnavailableTitle')}</DialogTitle>
            <DialogContent>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  textAlign: 'left',
                }}
              >
                <ErrorCircle20Filled style={{ color: '#7C0000' }} />
                <span>{t('feedbackUnavailableMessage')}</span>
              </div>
            </DialogContent>
            <DialogActions>
              <Button appearance="primary" onClick={onClose}>
                {t('feedbackUnavailableClose')}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </FluentProvider>
  );
};
